export const ROLES = {
  Admin: 'AU',
  SalesManager: 'SM',
  SalesUser: 'SU',
  DirectorOfProjectManagement: 'DPM',
  ProjectManager: 'PM',
  GraphicDesigner: 'GD',
  SeniorGraphicDesigner: 'SGD',
  DesignEngineer: 'DE',
  PermitExpeditor: 'PE',
  InstallationManager: 'IM',
  SalesUserProjectManager: 'SUPM',
  ClientUser: 'CU',
  TechUser: 'TECH',
  SuperUser: 'SUPER'
}

export const ROLENAMES = {
  [ROLES.Admin]: 'Administrator',
  [ROLES.SalesManager]: 'Sales Manager',
  [ROLES.SalesUser]: 'Sales User',
  [ROLES.DirectorOfProjectManagement]: 'Director Of Project Management',
  [ROLES.ProjectManager]: 'Project Manager',
  [ROLES.GraphicDesigner]: 'Graphic Designer',
  [ROLES.SeniorGraphicDesigner]: 'Senior Graphic Designer',
  [ROLES.DesignEngineer]: 'Design Engineer',
  [ROLES.PermitExpeditor]: 'Permit Expeditor',
  [ROLES.InstallationManager]: 'Installation Manager',
  [ROLES.SalesUserProjectManager]: 'Sales User Project Manager',
  [ROLES.ClientUser]: 'Client User',
  [ROLES.TechUser]: 'Tech User',
  [ROLES.SuperUser]: 'Super User'
}
